// services/dashboardService.js - Dashboard API Client

const API_URL = process.env.REACT_APP_API_URL || 'https://jsa.arborascent.com';

class DashboardService {
  /**
   * Fetch all form links with pagination and filtering
   */
  async getLinks(options = {}) {
    const params = new URLSearchParams();
    if (options.page) params.append('page', options.page);
    if (options.limit) params.append('limit', options.limit);
    if (options.status) params.append('status', options.status);
    if (options.search) params.append('search', options.search);
    if (options.sortBy) params.append('sortBy', options.sortBy);
    if (options.sortOrder) params.append('sortOrder', options.sortOrder);

    const response = await fetch(`${API_URL}/api/dashboard/links?${params}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch links');
    }

    return response.json();
  }

  /**
   * Fetch single link with submission history
   */
  async getLink(shortCode) {
    const response = await fetch(`${API_URL}/api/dashboard/links/${shortCode}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch link details');
    }

    return response.json();
  }

  /**
   * Revoke a link
   */
  async revokeLink(shortCode) {
    const response = await fetch(`${API_URL}/api/dashboard/links/${shortCode}/revoke`, {
      method: 'POST',
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to revoke link');
    }

    return response.json();
  }

  /**
   * Resend PDF to Jobber
   */
  async resendPDF(shortCode) {
    const response = await fetch(`${API_URL}/api/dashboard/links/${shortCode}/resend-pdf`, {
      method: 'POST',
      credentials: 'include'
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to resend PDF');
    }

    return response.json();
  }

  /**
   * Get tenant stats
   */
  async getStats() {
    const response = await fetch(`${API_URL}/api/dashboard/stats`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch stats');
    }

    return response.json();
  }

  /**
   * Manually trigger job sync to add JSA links to existing active jobs
   */
  async syncJobs() {
    const response = await fetch(`${API_URL}/api/dashboard/sync-jobs`, {
      method: 'POST',
      credentials: 'include'
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to sync jobs');
    }

    return response.json();
  }

  /**
   * Get sync status for current tenant
   */
  async getSyncStatus() {
    const response = await fetch(`${API_URL}/api/dashboard/sync-status`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch sync status');
    }

    return response.json();
  }
}

export default new DashboardService();
